<template>
    <div class="bg-white rounded shadow-sm p-4 max-w-2xl mx-auto" v-if="receiptData">
      <div class="text-center mb-4">
        <div v-if="isSuccess" class="mb-4">
          <div class="d-inline-flex align-items-center justify-content-center bg-success-light rounded-circle" style="width: 48px; height: 48px;">
            <i class="fas fa-check text-success"></i>
          </div>
          <h2 class="h3 mt-2">{{ receiptData.free_transaction ? 'Transaction' : 'Payment' }} Successful</h2>
        </div>
        <div v-else class="mb-4">
          <div class="d-inline-flex align-items-center justify-content-center bg-danger-light rounded-circle" style="width: 48px; height: 48px;">
            <i class="fas fa-exclamation-triangle text-danger"></i>
          </div>
          <h2 class="h3 mt-2">Payment Failed</h2>
        </div>
      </div>
  
      <div v-if="needsReview" class="alert alert-warning mb-4">
        <i class="fas fa-exclamation-triangle me-2"></i>
        <strong>Review Required</strong>
        <p class="mb-0">Your payment has been authorized but requires review. We'll notify you once it’s processed.</p>
      </div>

      <div v-if="receiptData.error" class="mb-4 error-continer">
        <p class="text-center error-message">
          Your payment was declined. Please check your payment details or try a different payment method. If you continue to experience issues, please contact your bank or our customer support for assistance.
        </p>
      </div>
  
      <div class="mb-4">
        <h3 class="h4 mb-3">Transaction Details</h3>
        <div class="row g-3">
          <!-- <div class="col-sm-6">
            <label class="text-muted small">Transaction ID</label>
            <div class="font-monospace">{{ receiptData.id }}</div>
          </div> -->
          <div class="col-sm-6">
            <label class="text-muted small">Reference Number</label>
            <div>{{ reconciliationId }}</div>
          </div>
<!--           
          <div class="col-sm-6" v-if="receiptData.transaction.amount > 0">
            <label class="text-muted small">Total</label>
            <div class="fw-bold">
              ${{ formatAmount(receiptData.transaction.amount) }} {{ receiptData.transaction.currency }}
            </div>
          </div> -->

<!--           
          <div class="col-sm-6">
            <label class="text-muted small">Status</label>
            <div>{{ formatStatus(receiptData.status) }}</div>
          </div> -->
          
          <!-- <div class="col-sm-6" v-if="receiptData?.orderInformation?.amountDetails?.totalAmount">
            <label class="text-muted small">Total</label>
            <div class="fw-bold">
              ${{ formatAmount(receiptData?.orderInformation?.amountDetails?.totalAmount) }} {{ receiptData.transaction.currency }}
            </div>
          </div> -->

          <div class="col-sm-6" v-if="receiptData.transaction.amount > 0">
            <label class="text-muted small">Total</label>
            <div class="fw-bold">
              ${{ formatAmount(receiptData.transaction.amount) }} {{ receiptData.transaction.currency }}
            </div>
          </div>

          <div class="col-sm-6">
            <label class="text-muted small">Date</label>
            <div>{{ formatDate(receiptData.submitTimeUtc) }}</div>
          </div>
          
          <!-- <div class="col-sm-6">
            <label class="text-muted small">Reference</label>
            <div>{{ reconciliationId }}</div>
          </div> -->
        </div>
      </div>
<!--   
      <div v-if="receiptData.error" class="mb-4">
        <h3 class="h4 mb-3">Additional Information</h3>
        <p class="text-muted">{{ receiptData.error.message }}</p>
      </div> -->
  
      <div class="text-center mt-4" v-if="isSuccess && !needsReview">
        <p class="success-message">You will receive an email confirmation and receipt shortly.</p>

        <div v-if="additionalHtml" v-html="additionalHtml" class="additional-html"></div>

        <p class="return-home-link-container" v-if="homeLink?.url && homeLink?.label">
          <a :href="homeLink.url" class="btn btn-primary return-home-link">{{ homeLink.label }}</a>
        </p>


        <!-- link button to href /event-attendee-transactions -->
        <!-- <a href="/event-attendee-transactions" class="btn btn-link">
          <i class="fas fa-ticket me-2"></i> My Tickets
        </a> -->

      </div>


      <div class="text-center mt-4" v-if="!isSuccess">
        <button class="btn btn-primary" @click="refreshPage" >
          Click here to try again
        </button>
      </div>

    </div>
  </template>
  
  <script>
  export default {
    props: {
      receiptData: {
        type: Object,
        required: true
      },
      homeLink: {
        type: Object,
        required: false
      },
      additionalHtml: {
        type: Object,
        required: false
      }
    },
  
    computed: {
      isSuccess() {
        if (this.receiptData.free_transaction) {
          return true;
        }
        return this.receiptData.authorized && this.receiptData.status !== 'ERROR';
      },
  
      needsReview() {
        return this.receiptData.status === 'AUTHORIZED_PENDING_REVIEW';
      },

      reconciliationId () {
        return this.receiptData.reconciliationId || this.receiptData.id;
      }

    },
  
    methods: {
      formatDate(dateString) {
        if (!dateString) return '';
        return new Date(dateString).toLocaleString();
      },
  
      formatAmount(amount) {
        return parseFloat(amount).toFixed(2);
      },
  
      formatStatus(status) {
        if (!status) return '';
        return status.replace(/_/g, ' ').toLowerCase()
          .replace(/\b\w/g, l => l.toUpperCase());
      },
  
      printReceipt() {
        window.print();
      },

      refreshPage() {
        window.location.reload();
      }
    }
  }
  </script>
  
  <style scoped>

a, a:link, a:visited, a:hover, a:active {
    text-decoration: none;
    color: white;
  }

  .bg-success-light {
    background-color: rgba(40, 167, 69, 0.1);
  }
  
  .bg-danger-light {
    background-color: rgba(220, 53, 69, 0.1);
  }
  
  .font-monospace {
    font-family: monospace;
  }
  
  @media print {
    .btn-link {
      display: none;
    }
  }
  </style>